export function EyeOpen(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="14"
        viewBox="0 0 24 14"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 0.799988C5.89949 0.799988 0.800049 3.34971 0.800049 6.99999C0.800049 10.6503 5.89949 13.2 12 13.2C18.1006 13.2 23.2 10.6503 23.2 6.99999C23.2 3.34971 18.1006 0.799988 12 0.799988ZM14.4894 3.36757C18.1802 3.87524 20.8 5.45626 20.8 6.99999C20.8 8.39831 18.6505 9.82723 15.5025 10.4613C16.3048 9.64866 16.8 8.53215 16.8 7.29999C16.8 5.60945 15.8678 4.13665 14.4894 3.36757ZM10.2769 3.27934C6.18779 3.66034 3.20005 5.35143 3.20005 6.99999C3.20005 8.50453 5.68857 10.0445 9.23168 10.5917C8.35083 9.77024 7.80005 8.59944 7.80005 7.29999C7.80005 5.54235 8.80773 4.02007 10.2769 3.27934Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
